import PageMeta from "../../components/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import SignInForm from "../../components/auth/SignInForm";

export default function SignIn() {

  return (
    <>
      <PageMeta
        title="Log In to - Neo"
        description="Access the Neo console to track sales, analyze KPIs, monitor store performance, and make smarter business decisions with real-time eCommerce insights."
      />
      <AuthLayout hideSignupHighlight>
        <SignInForm />
      </AuthLayout>
    </>
  );
}
